<!-- eslint-disable vue/html-self-closing -->
<template>
  <section
    v-if="getActionAvailabilityFlag(ACTION_ENUM.CREATE_ISSUE_NOTE) && hasAccessToComment"
    class="issue-discussion-form"
  >
    <div
      v-show="isEditorShown"
      class="issue-discussion-form__discussion"
    >
      <gf-custom-text-editor
        editor-variant="editor"
        :has-close-button="true"
        :submit-button-text="$t('message.send')"
        :placeholder="$t('message.leave_comment_here')"
        @close="onEditorClose"
        @submit="submitDiscussion"
      />
    </div>
  </section>
</template>

<script>
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import GfCustomTextEditor from '@/shared-modules/shared-components/shared/GfCustomTextEditor';

export default {
  name: 'IssueDiscussionForm',
  components: { GfCustomTextEditor },
  props: {
    discussion: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      isEditorShown: false,
      replyModel: null
    };
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    hasAccessToComment() {
      return document.querySelector('head meta[name="uuid"]');
    }
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    openEditor() {
      this.isEditorShown = true;
    },
    onEditorClose() {
      this.isEditorShown = false;
      this.$emit('close');
    },
    async submitDiscussion(data) {
      const str = await data;
      this.replyModel = str;
      const regexp = /[^\s\r\n]+/;
      const result = regexp.test(str);
      if (!result) return false;
      if (str !== undefined) {
        this.$emit('submit', this.replyModel);
        this.replyModel = '';
        delete this.replyModel;
      }
      this.isEditorShown = false;
    }
  }
};
</script>
